// data/trust.ts
//
// Shared constants for Airbnb Superhost trust signals.
// One source of truth — update `reviewsCount` quarterly from the Airbnb
// profile and everything (eyebrow badge, footer trust-line) rerenders.

export const trustStats = {
  rating: 5.0,
  reviewsCount: 54,
  superhostSince: 2023,
  airbnbProfileUrl: 'https://www.airbnb.com/users/profile/1465883899966328902',
} as const

export type TrustStats = typeof trustStats
